import * as React from 'react';
import { Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export interface IModalMessageProps {
    isOpen: boolean;
    modalHeader: string;
    modalBody: string;
    children?: React.ReactNode;
    onClickYes: (e: React.SyntheticEvent) => void;
    onClickNo: () => void;
    eMailToCourseProvider: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ModalMessageToEmail = (props: IModalMessageProps) => {
    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>{props.modalHeader}</ModalHeader>
            <ModalBody>
                {props.modalBody}
                <Input name="messageToCourseProvider" type="textarea" onChange={props.eMailToCourseProvider} />
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-primary w-50" onClick={props.onClickNo}>
                    Abbrechen
                </button>
                <button className="btn btn-danger w-50" onClick={props.onClickYes}>
                    Senden
                </button>
            </ModalFooter>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/modalMessageToEmail/ModalMessageToEmail.tsx